var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5352 12.4555C22.5352 11.9378 22.1154 11.518 21.5977 11.518L18.4819 11.518V8.40224C18.4819 7.88447 18.0621 7.46474 17.5444 7.46474C17.0266 7.46474 16.6069 7.88447 16.6069 8.40224V12.4555C16.6069 12.9733 17.0266 13.393 17.5444 13.393L21.5977 13.393C22.1154 13.393 22.5352 12.9733 22.5352 12.4555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5444 22.5351C18.0622 22.5351 18.4819 22.1154 18.4819 21.5976L18.4819 18.4818L21.5977 18.4818C22.1155 18.4818 22.5352 18.0621 22.5352 17.5443C22.5352 17.0266 22.1155 16.6068 21.5977 16.6068L17.5444 16.6068C17.0266 16.6068 16.6069 17.0266 16.6069 17.5443L16.6069 21.5976C16.6069 22.1154 17.0266 22.5351 17.5444 22.5351Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4556 22.5351C11.9378 22.5351 11.5181 22.1154 11.5181 21.5976V18.4818H8.40225C7.88449 18.4818 7.46475 18.0621 7.46475 17.5443C7.46475 17.0266 7.88449 16.6068 8.40225 16.6068L12.4556 16.6068C12.9733 16.6068 13.3931 17.0266 13.3931 17.5443L13.3931 21.5976C13.3931 22.1154 12.9733 22.5351 12.4556 22.5351Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46478 12.4555C7.46478 11.9378 7.88452 11.518 8.40228 11.518H11.5181L11.5181 8.40224C11.5181 7.88447 11.9378 7.46474 12.4556 7.46474C12.9734 7.46474 13.3931 7.88447 13.3931 8.40224L13.3931 12.4555C13.3931 12.9733 12.9734 13.393 12.4556 13.393L8.40228 13.393C7.88452 13.393 7.46478 12.9733 7.46478 12.4555Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollapse);
export default __webpack_public_path__ + "static/media/icon_collapse.fada7d742233591ae5bb1f6f32a50790.svg";
export { ForwardRef as ReactComponent };